module.exports = __webpack_public_path__ + "static/media/ugbs-logo.b5d445ec.png";